<template>
  <div style="height: 100%; position: relative" class="mapDiv">
    <div id="map" class="map"></div>
    <c-name
      v-if="JSON.stringify(param) !== '{}'"
      :param="param"
      class="detail"
    ></c-name>
  </div>
</template>

<script>
import L from "leaflet";
// import "leaflet/dist/leaflet.css";
// import cDetail from '../util/detail'
import changeMap from "../util/changeMap";
import cName from "../util/name";
import { findDataProjectByDataProjectTypeIdNYDP } from "@/api/base";
import { mapGetters } from "vuex";
export default {
  components: {
    cName
  },
  data() {
    return {
      map: null,
      hoverList: [],
      ncIndex: null,
      ncCode: "",
      param: {},
      poisiton: {}
    };
  },
  computed: {
    ...mapGetters(["rightComponent"])
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      var url = require("images/map/dt1.png");
      var map = L.map("map", {
        minZoom: 17,
        maxZoom: 20,
        center: [-0.00200653076171875, 0.0021896362304687],
        zoom: 17,
        crs: L.CRS.Simple,
        attributionControl: false
      });
      this.map = map; //data上需要挂载
      window.map = map;
      var northEast = this.map.unproject([2271, 0], this.map.getMaxZoom() - 1); //东北 右上角northEast
      var southWest = this.map.unproject([0, 2406], this.map.getMaxZoom() - 1); //西南 左下角southWest
      var bounds = new L.LatLngBounds(southWest, northEast);
      L.imageOverlay(url, bounds, { interactive: false }).addTo(map);
      // map.setMaxBounds(bounds);//设置了地图和图片一样大小，取消之后，自定义地图可以随意拖拽
      map.on("click", e => {
        console.log(e.latlng);
      });
      map.on("move", () => {
        this.param = {};
      });
      this.areaLoad();
      this.qutzLoad();
    },
    //区域数据加载
    areaLoad() {
      let areaArr = this.$config.areaArr;
      this.mianArr = [];
      for (let i = 0, len = areaArr.length; i < len; i++) {
        L.polygon(areaArr[i].rings, {
          color: areaArr[i].color,
          fillColor: areaArr[i].color,
          fillOpacity: 0.5,
          attributes: areaArr[i]
        }).addTo(this.map);
      } // this.areaLoad1();
    },

    //获取园区总投资数据
    qutzLoad() {
      findDataProjectByDataProjectTypeIdNYDP({ dataProjectTypeId: "" }).then(
        res => {
          let lists = res.data;
          let sj = [];
          let sj1 = 0;
          let sj2 = 0;
          let sj3 = 0;
          let sj4 = 0;
          lists.map(it => {
            let sbjes = it.planFundTotal;
            if (sbjes > 0 && sbjes <= 50) {
              sj1 = sj1 + 1;
            } else if (sbjes > 50 && sbjes <= 100) {
              sj2 = sj2 + 1;
            } else if (sbjes > 100 && sbjes <= 200) {
              sj3 = sj3 + 1;
            } else {
              sj4 = sj4 + 1;
            }
          });
          sj = [
            {
              tc_name: "全部(" + res.data.length + ")",
              tc_pic: "icon_all.png"
            },
            {
              tc_name: "0-50 万元(" + sj1 + ")",
              tc_pic: "icon_first.png"
            },
            {
              tc_name: "50-100 万元(" + sj2 + ")",
              tc_pic: "icon_second.png"
            },
            {
              tc_name: "100-200 万元(" + sj3 + ")",
              tc_pic: "icon_third.png"
            },
            {
              tc_name: ">200 万元(" + sj4 + ")",
              tc_pic: "icon_fourth.png"
            }
          ];
          this.$store.dispatch("map/setBottomList", sj);
          res.data.map(it => {
            if (it.latitude) {
              let aPoint = new changeMap(it.latitude, it.longitude);
              console.log("apoint", aPoint.lat, aPoint.lng);
              it.lat = aPoint.lat;
              it.lng = aPoint.lng;
              //   it.lat = it.latitude;
              //   it.lng = it.longitude;
              let iconImg;
              let sbje = it.planFundTotal;
              if (sbje > 0 && sbje <= 50) {
                iconImg = require("images/map/icon_first_c.png");
              } else if (sbje > 50 && sbje <= 100) {
                iconImg = require("images/map/icon_second_c.png");
              } else if (sbje > 100 && sbje <= 200) {
                iconImg = require("images/map/icon_third_c.png");
              } else {
                iconImg = require("images/map/icon_fourth_c.png");
              }
              let pointIcon = L.icon({
                iconUrl: iconImg,
                iconSize: [30, 30],
                iconAnchor: [10, 40],
                popupAnchor: [0, 0]
              });
              let ssztLayer = L.marker([it.lat, it.lng], {
                icon: pointIcon,
                attributes: it
              }).addTo(this.map);
              ssztLayer.on("click", e => {
                // 缓存rightcomponent
                sessionStorage.setItem("rightComponent", this.rightComponent);
                setTimeout(() => {
                  this.$store.dispatch(
                    "drawer/setGraphic",
                    e.sourceTarget.options.attributes
                  );
                  this.$store.dispatch(
                    "drawer/setRightComponent",
                    "yqztzDrawer"
                  );
                }, 10);
              });
              ssztLayer.on("mouseover", it => {
                this.param = {
                  x: it.containerPoint.x,
                  y: it.containerPoint.y,
                  name: it.sourceTarget.options.attributes.name
                };
                this.ncCode = it.target.options.attributes.code;
              });
              ssztLayer.on("mouseout", () => {
                this.param = {};
              });
            }

            this.$bus.$emit("updXmjsData", res.data);
          });
        }
      );
    }
  },
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="stylus" scoped>
.map
  background none !important
  width 100%
  height calc(100% + 105px)
  z-index 9
  // >>>.leaflet-tile-pane
  // display none
  >>>.leaflet-bar
    display none
  >>>.leaflet-bottom
    display none
  .ncDetail
    position absolute
@media (max-width 1280px)
  .mapDiv
    transform scale(0.75)
</style>
